// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","button":"backButton_button__6XU3j","button--project-inner":"backButton_button--project-inner__QHUlQ","no-hover":"backButton_no-hover__uzdyC"};